import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import image from '../../assets/unauthorized.jpg';
import Logout from './Logout';

const RestrictAccess = ({ allowedRoles, children }) => {
	const { t } = useTranslation();
	const { keycloak } = useKeycloak();
	const contactMail = "info@ekovaruh.si";

	const hasRole = (roles) => {
		if (!keycloak || !keycloak.tokenParsed || !keycloak.authenticated) {
			return false;
		}

		return roles.some((role) => keycloak.hasRealmRole(role));
	};

	const hasCompany = () => {
		if (!keycloak || !keycloak.tokenParsed) {
			return false;
		}
		const { company } = keycloak.tokenParsed;
		return !!company;
	};

	if (hasRole(allowedRoles) && !hasCompany()) {
		return (
			<>
				<Link
					to={t('navigation.href.settings')}
					className="notification-banner">
					{t('company_is_required_notification')}
				</Link>
				{children}
			</>
		);
	} else if (hasRole(allowedRoles) && hasCompany()) {
		return children;
	} else {
		return (
			<div className="unauthorized-banner">
				<img src={image} alt="" />
				<div>
					<Logout />
					<div>
						<h1>{t('unauthorized')}</h1>
						<div>{t('unauthorized_contact')}: <a href={`mailto:${contactMail}`}>{contactMail}</a></div>
					</div>
				</div>
			</div>
		);
	}
};

export default RestrictAccess;
